import Button from "@material-ui/core/Button";
import React, {createRef, Fragment, useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import InputLabel from "@material-ui/core/InputLabel";
import Box from "@material-ui/core/Box";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import HTTPClient from "../../HTTPClient";
import Loading from "../Loading";
import config from "../../config.json";
import {getMessage} from "../../util";

const useStyles = makeStyles(theme => ({
        paper: {
            marginTop: theme.spacing(4),
            marginBottom: theme.spacing(2),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'left',
        },
        voted: {
            marginTop: theme.spacing(4),
        },
        paragraph: {
            margin: theme.spacing(2)
        },
        cardGrid: {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8),
        },
        number: {
            fontFamily: "Montserrat"
        },
        card: {
            marginTop: theme.spacing(4),
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
        },
        cardActions: {
            justifyContent: 'center',
        },
        cardContent: {
            flexGrow: 1,
        },
        option: {
            margin: theme.spacing(3),
            display: 'flex',
            flexDirection: 'column',

        },
        label: {
            alignItems: 'left',
            color: 'black'
        },
        textField: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
            width: '25ch',
        },

    }
));

const sep = (() => {
    const n = 1.1;
    return(n.toLocaleString(navigator.language).substring(1, 2));
})();

const getRealNumber = (s_value) => {

    if(typeof s_value === "number") {
        return (s_value);
    }

    if (sep === ",") {
        return (Number(s_value.replace(/[^,0-9]/g, "").replace(/,/g,".")) || 0);
    } else {
        return (Number(s_value.replace(/[^\.0-9]/g, "")) || 0);
    }
}

const roundTo = (value,precision) => {
    const exp = Math.pow(10,precision);
    return(Math.round(exp*value)/exp);
}

const TooMany = (props) => {
    return (<Dialog
        open={true}
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <DialogTitle id="alert-dialog-title">{getMessage(props.meeting.meeting_type, 'answer_too_much_title', props.messages)}</DialogTitle>
        <DialogContent>
            <DialogContentText id="alert-dialog-description">
                {getMessage(props.meeting.meeting_type, 'answer_too_much_message', props.messages)}

            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={props.handleClose} color="primary" autoFocus>
                {getMessage(props.meeting.meeting_type, 'close', props.messages)}
            </Button>
        </DialogActions>
    </Dialog>)
}

const Resume = (props) => {
    const classes = useStyles();
    const [loading, setLoading] = useState(false);

    const question_shares = Object.keys(props.question.blanks);
    const representative_question = Object.keys(props.user.shares).filter((x) => {
        if (question_shares.indexOf(x) === -1)
            return false;
        else
            return true;
    });

    const vote = () => {

        const data = props.answers.map(a => {
            return ({option_id: a._id, votes: a.votes})
        });
        setLoading(true);
        HTTPClient({
            method: "post",
            data: {answers: data},
            url:
                process.env.REACT_APP_API_URL +
                "/meetings/" + props.meeting.slug + "/questions/" + props.question.slug + "/vote"
        })
            .then(response => {

                setLoading(false);

                if (response.data) {
                    props.vote();
                } else {
                    window.alert(getMessage(props.meeting.meeting_type, 'answer_cannot_sent', props.messages));

                }

            }).catch((error) => {
            console.log(error);
            window.alert(getMessage(props.meeting.meeting_type, 'answer_cannot_sent', props.messages));
            setLoading(false);

        });


    }


    return (<Dialog
        open={true}
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <DialogTitle id="alert-dialog-title">
            {getMessage(props.meeting.meeting_type, 'answer_confirm_title', props.messages)}
        </DialogTitle>
        <DialogContent>

            {props.answers && props.answers.sort((a, b) => {
                return (a.order - b.order);
            }).map(a => (
                    <DialogContentText className={classes.label} key={"o" + a._id}>
                        {a.name}: <br/>
                        {Object.keys(a.votes).map(k => (
                            <Fragment key={k}>
                                {a.votes[k].name}: <span
                                className={classes.number}> {a.votes[k].shares.toLocaleString(navigator.language, {
                                maximumFractionDigits: config.precision
                            })}</span>
                                <br/>
                            </Fragment>
                        ))}


                    </DialogContentText>

            ))}

                <DialogContentText>
                    {getMessage(props.meeting.meeting_type, 'blanks', props.messages)}: <br/>
                    {representative_question.map(k => (
                        <Fragment key={k}>
                            {props.user.shares[k].name}: <span
                            className={classes.number}>{(props.user.shares[k].shares - props.shares[k]).toLocaleString(navigator.language, {
                            maximumFractionDigits: config.precision
                        })}</span>
                            <br/>
                        </Fragment>
                    ))}
                </DialogContentText>




        </DialogContent>
        {loading ? (
            <Loading/>

        ) : (
            <DialogActions>
                <Button onClick={props.handleClose} autoFocus>
                    {getMessage(props.meeting.meeting_type, 'back', props.messages)}
                </Button>
                <Button variant="contained" color={"primary"} onClick={vote}>
                    {getMessage(props.meeting.meeting_type, 'answer_confirm_button', props.messages)}
                </Button>
            </DialogActions>

        )}


    </Dialog>);
}

const OptionsDistributed = (props) => {

    const classes = useStyles();
    const [resume, setResume] = useState(false);

    const [shares, setShares] = useState(Object.keys(props.user.shares).reduce((acc, k) => {
        acc[k] = 0;
        return (acc);
    }, {}));
    const [tooMany, setTooMany] = useState(false);
    const [answers, setAnswers] = useState(props.question.options.map(o => {
        o.votes = Object.keys(props.user.shares).reduce((acc, k) => {
            acc[k] = {
                name: props.user.shares[k].name,
                shares: 0
            };
            return (acc);
        }, {});
        return (o)
    }));

    props.question.options.sort(function (a, b) {
        return a.order - b.order
    });


    const question_shares = Object.keys(props.question.blanks)
    const representative_question = Object.keys(props.user.shares).filter((x) => {
        if (question_shares.indexOf(x) === -1)
            return false;
        else
            return true;
    });

    const options = props.question.options.reduce((acc, elem) => {
        acc[elem._id] = Object.keys(props.user.shares).reduce((acc, k) => {
            acc[k] = {
                value: createRef(),
                percentage: createRef()
            }
            return (acc);
        }, {});
        return (acc);
    }, {});


    const vote = () => {
        /*
        {
            answers: [
            {
                option_id: String,
                votes: {
                    'A': {
                    name: String,
                    shares: Long
                    }
                }
            ]
        }
         */

        const votes = props.question.options.map(o => {
            const no = {};
            no._id = o._id;
            no.name = o.name;
            no.order = o.order;
            no.votes = representative_question.reduce((acc, k) => {
                acc[k] = {
                    name: props.user.shares[k].name,
                    shares: getRealNumber(options[o._id][k].value.current.value)
                }
                return (acc);
            }, {})

            return (no)
        });
        setAnswers(votes);
        setResume(true);
    }

    const updateValues = (id, serie) => {

        let s_value = options[id][serie].value.current.value;

        if (props.meeting.decimals) {
            // TODO: decimales o no
            // I remove forbidden chars
            s_value = s_value.replace(/[^,.0-9]/g, "");

            if (s_value.length > 2 && s_value.substr(s_value.length - 2,1) === sep && s_value.substr(s_value.length - 1) === "0") {
                // is putting zero after decimal separator, ignore
                return;
            }

            // I don't need to verify negatives because I replace everything different from number
            if (s_value.substr(s_value.length - 1) === "." || s_value.substr(s_value.length - 1) === ",") {
                // is putting decimal separator, ignore
                options[id][serie].value.current.value = s_value.substr(0, s_value.length - 1) + sep;
                return;
            }


        } else {
            // In any other meeting type decimals are not allowed
            s_value = s_value.replace(/[^0-9]/g, "");
        }

        const value = getRealNumber(s_value);

        if ( ((props.meeting.decimals && value === 0) ||(value % 1 !== 0)) && s_value.substr(s_value.length - 1) === "0") {
            return
        }

        const total = Object.keys(options).reduce((acc, elem) => {
            return (getRealNumber(options[elem][serie].value.current.value) + acc);
        }, 0);


        if (total > props.user.shares[serie].shares) {
            // over max
            setTooMany(true);
            options[id][serie].value.current.value = 0;
            options[id][serie].percentage.current.value = 0;
            // must force to have new share
            const new_share = Object.keys(props.user.shares).reduce((acc, k) => {
                acc[k] = shares[k];
                return (acc);
            }, {});
            new_share[serie] = Object.keys(options).reduce((acc, elem) => {
                return (getRealNumber(options[elem][serie].value.current.value) + acc);
            }, 0);
            setShares(new_share);
            return;
        }

        options[id][serie].percentage.current.value =  100*value / props.user.shares[serie].shares;

        // must force to have new share
        const new_share = Object.keys(props.user.shares).reduce((acc, k) => {
            acc[k] = shares[k];
            return (acc);
        }, {});
        new_share[serie] = total;
        options[id][serie].value.current.value = value.toLocaleString(navigator.language, {
            maximumFractionDigits: 20
        });
        setShares(new_share);
    }

    const updatePercentage = (id, serie) => {

        if (Object.keys(options).reduce((acc, elem) => {
            return (getRealNumber(options[elem][serie].percentage.current.value) < 0 || acc);
        }, false)) {
            // negatves
            setTooMany(true);
            options[id][serie].value.current.value = 0
            options[id][serie].percentage.current.value = 0;
            // must force to have new share
            const new_share = Object.keys(props.user.shares).reduce((acc, k) => {
                acc[k] = shares[k];
                return (acc);
            }, {});

            new_share[serie] = Object.keys(options).reduce((acc, elem) => {
                return (getRealNumber(options[elem].value.current.value) + acc);
            }, 0)
            setShares(new_share);

            return;
        }

        const total = Object.keys(options).reduce((acc, elem) => {
            return ((Number(options[elem][serie].percentage.current.value) || 0) + acc);
        }, 0);

        if (total > 100) {
            // to much
            setTooMany(true);
            options[id][serie].value.current.value = 0;
            options[id][serie].percentage.current.value = 0;
            // must force to have new share
            const new_share = Object.keys(props.user.shares).reduce((acc, k) => {
                acc[k] = shares[k];
                return (acc);
            }, {});
            new_share[serie] = Object.keys(options).reduce((acc, elem) => {
                return (getRealNumber(options[elem][serie].value.current.value) + acc);
            }, 0);
            setShares(new_share);
            return;
        }


        const percentage = Number(options[id][serie].percentage.current.value) || 0;

        const value =  props.meeting.decimls?roundTo(percentage * props.user.shares[serie].shares/100,config.precision):roundTo(percentage * props.user.shares[serie].shares/100,0);

        options[id][serie].value.current.value = value.toLocaleString(navigator.language, {
            maximumFractionDigits: config.precision
        });

        // it can be that the total get overloaded by 1
        const overload = props.meeting.decimals?(1/Math.pow(10,config.precision)):1
        if (getRealNumber(props.user.shares[serie].shares) + overload === Object.keys(options).reduce((acc, o) => {
            return (acc + getRealNumber(options[o][serie].value.current.value));
        }, 0)) {
            options[id][serie].value.current.value = roundTo(value - overload,config.precision).toLocaleString(navigator.language, {
                maximumFractionDigits: config.precision
            });
        }


        // must force to have new share
        const new_share = Object.keys(props.user.shares).reduce((acc, k) => {
            acc[k] = shares[k];
            return (acc);
        }, {});
        new_share[serie] = Object.keys(options).reduce((acc, elem) => {
            return (getRealNumber(options[elem][serie].value.current.value) + acc);
        }, 0);

        setShares(new_share);
        return;
    }

    return (

        <Fragment>
            {tooMany && <TooMany meeting={props.meeting} handleClose={() => setTooMany(false)}/>}
            {resume && <Resume answers={answers} shares={shares} question={props.question} meeting={props.meeting}
                               user={props.user}
                               handleClose={() => setResume(false)} vote={props.vote}/>}
            <Typography className={classes.paragraph}>
                {getMessage(props.meeting.meeting_type, 'vote_instruction', props.messages)}
            </Typography>

            <Grid container spacing={1}>
                <Grid item xs={12} sm={4} className={classes.state}>

                        <Typography className={classes.paragraph}>
                            {getMessage(props.meeting.meeting_type, 'shares_to_vote', props.messages)}
                            <br/>

                            {representative_question.map(k => (
                                <Fragment key={k}>
                                    {props.user.shares[k].name}: <span
                                    className={classes.number}>{props.user.shares[k].shares.toLocaleString(navigator.language, {
                                    maximumFractionDigits: config.precision
                                })}</span>
                                    <br/>
                                </Fragment>
                            ))}
                        </Typography>


                </Grid>
                <Grid item xs={12} sm={4} className={classes.state}>


                        <Typography className={classes.paragraph}>
                            {getMessage(props.meeting.meeting_type, 'shares_voting', props.messages)}
                            <br/>
                            <span>{representative_question.map(k => (
                                <Fragment key={k} >
                                    {props.user.shares[k].name}: <span  className={classes.number}>{shares[k].toLocaleString(navigator.language, {
                                    maximumFractionDigits: config.precision
                                })}</span>
                                    <br/>
                                </Fragment>
                            ))}</span>

                        </Typography>



                </Grid>
                <Grid item xs={12} sm={4} className={classes.state}>

                        <Typography className={classes.paragraph}>
                            {getMessage(props.meeting.meeting_type, 'shares_blanks', props.messages)}
                            <br/>
                            <span >{representative_question.map(k => (
                                <Fragment key={k}>
                                    {props.user.shares[k].name}: <span className={classes.number}>{(props.user.shares[k].shares - shares[k]).toLocaleString(navigator.language, {
                                    maximumFractionDigits: config.precision
                                })}</span>
                                    <br/>
                                </Fragment>
                            ))}</span>


                        </Typography>



                </Grid>
            </Grid>


            <Container className={classes.option}>

                <form className={classes.form} noValidate>
                    <Grid container spacing={2} alignItems={"center"}>
                        {representative_question.map(k => (
                            <Grid key={k} item xs={12}>
                                 <Container>
                                     <Typography variant={"h6"}>
                                         {props.user.shares[k].name}
                                     </Typography>
                                 </Container>
                                {props.question.options.sort((a, b) => {
                                    return (a.order - b.order);
                                }).map(o => (
                                    <Container key={o._id} className={classes.option}>


                                        <Box>
                                            <InputLabel htmlFor={o._id}
                                                        className={classes.label}>{o.name} </InputLabel>

                                            <TextField
                                                label={getMessage(props.meeting.meeting_type, 'shares', props.messages)}
                                                type="text"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                InputProps={{
                                                    className: classes.number,
                                                }}
                                                inputRef={options[o._id][k].value}
                                                id={"V-" + o._id}
                                                className={classes.textField}
                                                margin="dense"
                                                variant="outlined"
                                                onChange={() => updateValues(o._id, k)}
                                            />
                                            <TextField
                                                label="%"
                                                type="number"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                InputProps={{
                                                    className: classes.number,
                                                }}
                                                id={"P-" + o._id}
                                                inputRef={options[o._id][k]
                                                    .percentage}
                                                className={classes.textField}
                                                margin="dense"
                                                variant="outlined"
                                                onChange={() => updatePercentage(o._id, k)}
                                            />
                                        </Box>


                                    </Container>


                                ))}
                            </Grid>
                        ))}

                    </Grid>

                    <Container className={classes.option}>

                        <Button variant="contained" color={"primary"} onClick={vote}>
                            {getMessage(props.meeting.meeting_type, 'vote', props.messages)}
                        </Button>
                    </Container>


                </form>
            </Container>


        </Fragment>


    )
}

export default OptionsDistributed;